import { ElementsPanelProps } from '@wix/editor-platform-feature-store';
import { NormalizedData } from '@wix/editor-platform-host-integration-apis';

export const PLATFORM_ROOT_COMP_TYPE = 'platform.components.AppWidget';

export const INIT_NORMALIZED_DATA_STATE: NormalizedData = {
  data: {
    checkedState: {},
    compRefsMap: {},
  },

  sectionsWithItems: {},
  notInSectionItems: {
    unCategorizedItems: [],
    categoriesWithItems: {},
  },
};

export const EMTPY_ELEMENTS_PANEL_DATA: ElementsPanelProps = {
  data: {},
  items: [],
  removeHighlight: () => {},
  highlightComponent: () => {},
  onToggleState: () => Promise.resolve({}),
};
